(function (angular, app) {
   "use strict";

   // Alert
   angular.module(app.modules.ui.name)
      .controller(app.modules.ui.controllers.prepaid, PrepaidController);

   // Injector  
   PrepaidController.$inject = ["$scope"
   , app.modules.ui.services.ui
   , app.modules.common.services.functions
   ];

   function PrepaidController($scope
      , ggUISvc
      , ggFunctions
      ) {

      var ctrl = this;
      $scope.Temp = {
         window: ggFunctions.fetchWindowSize()
         , store: {
            sourceItemId: 0
            , amount: 0
            , clubId: 0
            , clubName: ""
            , discountCode: ""
            , description: ""
         }
         , callback: null
      }

      if ($scope.$parent && $scope.$parent.ngDialogData) {
         var data = $scope.$parent.ngDialogData;
         // Data
         $scope.Temp.store.sourceItemId = data.sourceItemId;
         $scope.Temp.store.clubId = data.clubId;
         $scope.Temp.store.clubName = data.clubName;
         $scope.Temp.store.amount = data.amount || 2995;
         $scope.Temp.store.description = data.description;
         $scope.Temp.store.discountCode = data.discountCode;
         $scope.Temp.store.isSubscription = data.isSubscription;
         if (data.callback) {
            $scope.Temp.callback = data.callback;
         }
      }

      $scope.Content = {
         prepaid: {
            alert: ""
            , form: {
               code: ""
            }
            , submit: function () {
               
               // Token Received.  Send to Server and charge card.
               var form = angular.copy($scope.Temp.store)
               form.code = $scope.Content.prepaid.form.code

               var updatePrepaidCode = function (form) {
                   return app.Member.Network.UpdatePrepaidCode(form);
               }
               $scope.Content.prepaid.alert = "";
               updatePrepaidCode(form).then(function (data) {
                  if ($scope.Temp.callback) {
                     $scope.Temp.callback({ msg: data.data.msg });
                  }
               }, function (fail) {
                   if (fail && fail.data && fail.data.error) {
                        $scope.Content.prepaid.alert = fail.data.error.msg;
                   } else {
                       $scope.Content.prepaid.alert = "There was an error processing the prepaid code.";
                   }
               }).finally(function () {
                  $scope.Temp.isProcessing = false;
               });

            }
         }

      }
   }
}(angular, app));
